import type React from 'react'
import type { VeliMigrationProgress } from '../../../redux/services/coreApi'

interface VeliMilestoneProps {
  progress: VeliMigrationProgress
}

// The Veli buy-out cutover, as a progress bar — a shared goal the whole office can rally behind.
// Hidden entirely when there are no Veli clients to migrate, so non-migration environments don't show
// an empty "0 of 0" bar.
const VeliMilestone: React.FC<VeliMilestoneProps> = ({ progress }) => {
  if (progress.totalClients === 0) return null

  const pct = Math.round(
    (progress.activatedClients / progress.totalClients) * 100
  )

  return (
    <div className="flex h-full flex-col justify-center">
      <div className="flex items-baseline justify-between">
        <h3 className="text-xs font-semibold uppercase tracking-widest text-white/40">
          Veli migration
        </h3>
        <span className="text-sm font-semibold text-white/60">{pct}%</span>
      </div>
      <div className="mt-3 flex items-baseline gap-2">
        <span className="text-3xl font-bold tabular-nums text-white xl:text-4xl">
          {progress.activatedClients.toLocaleString('en-US')}
        </span>
        <span className="text-sm text-white/40">
          of {progress.totalClients.toLocaleString('en-US')} clients activated
        </span>
      </div>
      <div className="mt-3 h-3 w-full overflow-hidden rounded-full bg-white/10">
        <div
          className="h-full rounded-full bg-gradient-to-r from-emerald-400 to-teal-300 transition-[width] duration-1000 ease-out"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  )
}

export default VeliMilestone
